<template src="./index.html"></template>
<script>
export default {
	name: '',
	components: {},
	props: {
		backsxdiag: {
			type: Boolean,
			default: false
		},
		unusedQuotaHasBeenDownloaded: ''
	},
	watch: {
		backsxdiag: function(indexVal, oldVal) {
			if (indexVal) {
				this.value=''
			}
		}
	},
	data: function() {
		return { value: '' };
	},
	created() {},
	methods: {
		//监听输入框
		MonitorInput() {
			if (parseInt(this.value) > parseInt(this.unusedQuotaHasBeenDownloaded)) {
				this.value = this.unusedQuotaHasBeenDownloaded;
			} else if (parseInt(this.value) < 0) {
				this.value = 0;
			}
		},
		//填入最大值
		FillMaximum() {
			this.value = this.unusedQuotaHasBeenDownloaded;
		},
		//退回
		Tuihui() {
			this.$https.fetchPost('/natural/credit/operationLineCredit?applyType=1&quota='+this.value).then(res => {
				if (res.data.code == '200') {
					this.$message.success('退回成功');
					this.closediag();
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		closediag() {
			this.$emit('closediag', false);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
